import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Card, CardContent, TextField, Button, InputAdornment, Autocomplete } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const LeaveSettingsFilters = ({
  searchTerm,
  employeeFilter,
  allEmployees,
  onSearchChange,
  onFilterChange,
  onClearFilters,
}) => {
  return (
    <Grid item xs={12}>
      <Card>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                placeholder="Search Employees"
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={onSearchChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <Autocomplete
                size="small"
                value={{
                  value: employeeFilter,
                  label:
                    employeeFilter === 'All'
                      ? 'All Employees'
                      : allEmployees.find((emp) => emp.id.toString() === employeeFilter.toString())?.full_name ||
                        employeeFilter,
                }}
                onChange={(event, newValue) => {
                  onFilterChange(newValue?.value || 'All');
                }}
                options={[
                  { value: 'All', label: 'All Employees' },
                  ...allEmployees.map((employee) => ({
                    value: employee.id,
                    label: employee.full_name,
                  })),
                ]}
                getOptionLabel={(option) => option?.label || ''}
                isOptionEqualToValue={(option, value) => option?.value?.toString() === value?.value?.toString()}
                renderInput={(params) => <TextField {...params} label="Employee" />}
                clearOnEscape
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <Button variant="outlined" onClick={onClearFilters} size="small" sx={{ height: '40px' }}>
                Clear Filters
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

LeaveSettingsFilters.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  employeeFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  allEmployees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      full_name: PropTypes.string.isRequired,
    })
  ).isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
};

export default LeaveSettingsFilters;
